import React, { useEffect, useState } from 'react';
import { ENDPOINTS } from '../utils/EndPoint';
import { apiGetAuth } from '../utils/Api';
import { useNavigate } from 'react-router-dom';

function AllBadges() {
  const [activeTab, setActiveTab] = useState('ocean');


  const [badges, setBadges] = useState([]);

  const navigate = useNavigate();


  const getBadges = async () => {
    apiGetAuth(
      `${ENDPOINTS.GetBadges}`,
      (res) => {
        console.log(res, 'resres');
        
        setBadges(res);
      },
      (err) => {
        console.log("Error fetching badges", err);
      }
    );
  };

  useEffect(() => {
    getBadges();
  }, []);

  return (
    <div className='px-4 achievement'>
      <div className='d-flex justify-content-between'>
        <h1 className='mt-3 text-white'>Badges</h1>
      </div>
      <div>

        {/* Tab Content */}
        <div className="tab-content mt-3">
          <div className="tab-pane active">
            {badges.length ? (
              <div className="row">
                {badges.map((badge) => (
                  <div key={badge.id} className="col-md-3 mb-4">
                    <div className="badge-card shadow p-3 bg-white rounded" style={{ filter: badge.user_badge ? 'none' : 'grayscale(100%)' }}>
                      <img src={`${process.env.REACT_APP_BASE_URL}/${badge.avatar}`} alt={badge.goal_name} className="badge-img" />
                      <h5 className="badge-title">{badge.goal_name}</h5>
                      <p className="badge-description">{badge.description.replace(/<[^>]*>/g, '')}</p>
                      <p>Number Of Stages: {badge.number_of_stages}</p>
                      <p className="badge-reward">Coins Reward: {badge.coins_reward} coins</p>
                    </div>
                  </div>
                ))}
              </div>
            ) : (
              <p className='text-white'>No Ocean Badges Available</p>
            )}
          </div>
        </div>

      </div>
    </div>
  );
}

export default AllBadges;
